import { IRoute } from "../../../common/helpers/routesMapper";
import { seo } from "../../../common/helpers/seo";

import image from "./image";

import lazyComponent from "./lazy";

export default {
    component: lazyComponent,
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        return seo({
            title: allMessage["article.covid.title"],
            description: allMessage["article.covid.p1"],
            allMessage,
            lang,
            image,
        });
    },
} satisfies IRoute;
